import React from 'react'
import { useDevice } from 'device'
import { track } from 'analytics'

import { Grid } from 'components/layout'
import ProductCardSmall, { ProductData } from 'compositions/productCards/ProductCardSmall/ProductCardSmall'
import ProductCardSmallSkeleton from 'compositions/productCards/ProductCardSmallSkeleton/ProductCardSmallSkeleton'


type ProductsGridProps = {
  products: Array<ProductData>
  className?: string
  query: string
  isFetching?: boolean
  'data-testid': string
}

const PRODUCT_BUTTON_PROPS = {
  metadata: {
    placement: 'Search',
  },
}

const PRODUCTS_SKELETON = new Array(6).fill(null).map((value, index) => (
  <ProductCardSmallSkeleton key={index} />
))

const ProductsGrid: React.FunctionComponent<ProductsGridProps> = (props) => {
  const { products, isFetching, className, query, 'data-testid': dataTestId } = props

  const { isMobile } = useDevice()

  const columns = isMobile ? '2-center' : '6-center'

  const createOnItemClick = (product: ProductData) => {
    return () => {
      const params: Analytics.Events['Search product name click'] = {
        query,
        productBrand: product.brand,
        productCategory: product.category,
        productFullName: product.fullName,
        productGender: product.gender,
        productId: product.id,
        rating: product.rating?.avgRate,
      }

      if (product.tradingItems?.items?.[0]?.volume) {
        const { volume, unit } = product.tradingItems.items[0].volume

        params.productVolume = `${volume} ${unit}`
      }

      track('Search product name click', params)
    }
  }

  return (
    <Grid
      className={className}
      align="stretch"
      columns={columns}
      gutter={16}
      data-testid={dataTestId}
    >
      {
        isFetching ? PRODUCTS_SKELETON : products.map((product) => (
          <Grid.Cell key={product.id}>
            <ProductCardSmall
              data={product}
              buttonProps={PRODUCT_BUTTON_PROPS}
              onLinkClick={createOnItemClick(product)}
            />
          </Grid.Cell>
        ))
      }
    </Grid>
  )
}

export default ProductsGrid
